import gql from 'graphql-tag';

const deleteTagMutation = gql`
  mutation DeleteTag($tagId: ID!) {
    deleteTag(tagId: $tagId)
  }
`;

export default {
  mutation: deleteTagMutation,
  module: 'tags',
  isSilent: true,
  buildVariables: ({ tagId }) => ({
    tagId
  })
};